var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.adibusForm = new (function () {
    var self = this;

    function compare(a, b) {
        if (a.LineNumber < b.LineNumber) {
            return -1;
        }
        if (a.LineNumber > b.LineNumber) {
            return 1;
        }
        return 0;
    }

    function onlyUnique(value, index, self) {
        if (!value.endsWith(" ")) {
            return self.indexOf(value) === index;
        } else {
            if (self.indexOf(value.substr(0, value.length - 1)) === index) {
                return (
                    self.indexOf(value.substr(0, value.length - 1)) === index
                );
            } else {
                return self.indexOf(value) === index;
            }
        }
    }

    this.apis = {
        getBusList: function (date, cb) {
            $.get(
                "/umbraco/api/adibus/getbuslist/?date=" + date,
                {},
                function (data, status, xh) {
                    cb(data);
                }
            );
        },

        getDepartureBusStop: function (date, busId, busNumber, cb) {
            $.get(
                "/umbraco/api/adibus/getbuslinestopsnames?date=" +
                    date +
                    "&busId=" +
                    busId +
                    "&busNumber=" +
                    busNumber,
                {},
                function (data, status, xh) {
                    cb(data);
                }
            );
        },

        getRouteDestination: function (
            date,
            busId,
            busNumber,
            busStopDeparture,
            cb
        ) {
            $.get(
                "/umbraco/api/adibus/getbuslineendstop?date=" +
                    date +
                    "&busId=" +
                    busId +
                    "&busNumber=" +
                    busNumber +
                    "&busStopDeparture=" +
                    busStopDeparture,
                {},
                function (data, status, xh) {
                    cb(data);
                }
            );
        },

        getDepartureTime: function (
            date,
            busId,
            busNumber,
            busStopDeparture,
            busEndStop,
            cb
        ) {
            $.get(
                "/umbraco/api/adibus/gettimesforbusstopdeparture?date=" +
                    date +
                    "&busId=" +
                    busId +
                    "&busNumber=" +
                    busNumber +
                    "&busStopDeparture=" +
                    busStopDeparture +
                    "&busEndStop=" +
                    busEndStop,
                {},
                function (data, status, xh) {
                    cb(data);
                }
            );
        },

        getNextBusLineStops: function (
            date,
            busId,
            busNumber,
            tourNumber,
            busStopDeparture,
            cb
        ) {
            $.get(
                "/umbraco/api/adibus/getnextbuslinestops?date=" +
                    date +
                    "&busId=" +
                    busId +
                    "&busNumber=" +
                    busNumber +
                    "&tourNumber=" +
                    tourNumber +
                    "&busStopDeparture=" +
                    busStopDeparture,
                {},
                function (data, status, xh) {
                    cb(data);
                }
            );
        },
    };

    this.ids = {};

    this.init = function (ids) {
        $(function () {
            self.ids = ids;

            $(
                "#" +
                    ids.busListField +
                    ", #" +
                    ids.departureStopField +
                    ", #" +
                    ids.destinationField +
                    ", #" +
                    ids.departureTimeField +
                    ", #" +
                    ids.arrivalStopField +
                    ", #" +
                    ids.arrivalTimeField +
                    ", .rutenr_helptext, .fallback_helptext"
            )
                .closest(".contourField")
                .addClass("disabled");

            $(".singlechoice div .radiobuttonlist").on(
                "change",
                self.onRadioButtonChange
            );
            $("#" + ids.travelTypeField).on("change", self.onTravelTypeChange);
            $("#" + ids.travelCompanyField).on(
                "change",
                self.onTravelCompanyChange
            );
            $("#" + ids.dateField).on("change", self.onDatepickerChange);
            $("#" + ids.busListField).on(
                "typeahead:select",
                self.onRouteListChange
            );
            $("#" + ids.busListField).on("keypress", self.onRouteListChange);
            $("#" + ids.departureStopField).on("change", self.onFromStopChange);
            $("#" + ids.destinationField).on(
                "change",
                self.onDestionationChange
            );
            $("#" + ids.departureTimeField).on(
                "change",
                self.onDepartureTimeChange
            );
            $("#" + ids.arrivalStopField).on(
                "change",
                self.onArrivalBusStopChange
            );
            $("#" + ids.arrivalTimeField).on(
                "change",
                self.onArrivalTimeChange
            );

            // Check for params in case user is sent from external page
            var params = new URLSearchParams(document.location.search);

            if (params.size > 0) {
                var routeTypeRadioButtons = document.querySelectorAll(
                    'input[name="' + self.ids.travelTypeField + '"]'
                );
                var routeChangeRadioButtons = document.querySelectorAll(
                    'input[name="8e35b131-cdc9-4424-b75f-ef082364630d"]'
                );
                var travelCompanyRadioButtons = document.querySelectorAll(
                    'input[name="' + self.ids.travelCompanyField + '"]'
                );
                var caseId = params.get("caseId");
                var routeChange = params.get("routeChange");
                var date = params.get("date");
                var busId = parseInt(params.get("busId"));
                var busLineNumber = params.get("busNumber");
                var busLineStopDeparture = params.get("busStopDeparture");
                var busLineEndStop = params.get("busEndStop");
                var busLineTourNumber = params.get("tourNumber");
                var busLineStopArrival = params.get("busStopArrival");
                var travelType =
                    busLineNumber &&
                    (busLineNumber === "L1" ||
                        busLineNumber === "L2" ||
                        busLineNumber === "92Tog" ||
                        busLineNumber === "93Tog")
                        ? "Letbanen/Midtjyske Jernbaner"
                        : busLineNumber
                        ? "Bus"
                        : "";

                function setTravelTypeField() {
                    $(routeTypeRadioButtons).each(function () {
                        if ($(this)[0].value === travelType) {
                            $(this).prop("checked", true);
                            return $(".skulleduskifteundervejs").css(
                                "display",
                                "block"
                            );
                        }
                    });

                    if (routeChange && routeChange !== "") {
                        setRouteChangeField();
                    }
                }

                function setRouteChangeField() {
                    $(routeChangeRadioButtons).each(function () {
                        if (
                            $(this)[0].value.toLowerCase() ===
                            routeChange.toLowerCase()
                        ) {
                            $(this).prop("checked", true);
                            if ($(this)[0].value.toLowerCase() === "nej") {
                                $("#" + self.ids.dateField)
                                    .closest(".contourField")
                                    .removeClass("disabled")
                                    .addClass("active");
                                $("#16c36af8-fbf3-4ce7-b85d-99bdd026600d").css(
                                    "display",
                                    "block"
                                );
                            } else if (
                                $(this)[0].value.toLowerCase() === "ja"
                            ) {
                                $(".hvemrejstedumed").css("display", "block");
                                $(".travelcompany_helptext").css(
                                    "display",
                                    "block"
                                );

                                $(travelCompanyRadioButtons).each(function () {
                                    if (
                                        $(this)[0].value.toLowerCase() ===
                                        "midttrafik"
                                    ) {
                                        $(this).prop("checked", true);
                                    }
                                });
                            } else {
                                return;
                            }
                        }
                    });

                    if (
                        date &&
                        busId &&
                        busLineNumber &&
                        busLineStopDeparture &&
                        busLineEndStop &&
                        busLineTourNumber &&
                        busLineStopArrival &&
                        caseId
                    ) {
                        populateDateField();
                    }
                }

                function populateDateField() {
                    try {
                        self.apis.getBusList(date, function (routes) {
                            if (busLineNumber && busId) {
                                populateRouteNumberField(
                                    JSON.parse(routes.Data)
                                );
                            }
                            $("#" + self.ids.dateField).val(date);
                        });
                    } catch (error) {
                        console.error(error);
                    }
                    $("#" + self.ids.dateField)
                        .closest(".contourField")
                        .removeClass("disabled")
                        .addClass("active");
                    $("#16c36af8-fbf3-4ce7-b85d-99bdd026600d").css(
                        "display",
                        "block"
                    );

                    $("input[type=date]").val(date);
                }

                function populateRouteNumberField(routes) {
                    var radioButtonField = document.querySelector(
                        'input[name="' + self.ids.travelTypeField + '"]:checked'
                    ).value;

                    if (radioButtonField === "Bus") {
                        routes = routes.sort(compare).filter(function (el) {
                            return (
                                el.LineNumber !== "L1" &&
                                el.LineNumber !== "L2" &&
                                el.LineNumber !== "92Tog" &&
                                el.LineNumber !== "93Tog"
                            );
                        });

                        window.Midttrafik2016.routeListTypeahead(
                            "#" + self.ids.busListField,
                            routes
                        );
                    } else {
                        routes = routes.sort(compare).filter(function (el) {
                            return (
                                el.LineNumber == "L1" ||
                                el.LineNumber == "L2" ||
                                el.LineNumber == "92Tog" ||
                                el.LineNumber == "93Tog"
                            );
                        });

                        window.Midttrafik2016.routeListTypeahead(
                            "#" + self.ids.busListField,
                            routes
                        );
                    }

                    var filteredRoute = routes.filter(function (obj) {
                        return (
                            obj.LineNumber === busLineNumber &&
                            obj.RawdataId === busId
                        );
                    });
                    $("#" + self.ids.busListField).val(
                        filteredRoute[0].LineDisplayText
                    );
                    if (busLineNumber) {
                        $()
                            .closest(".contourField")
                            .removeClass("disabled")
                            .addClass("active");
                    }

                    $(
                        "#" +
                            self.ids.busListField +
                            ", .rutenr_helptext, .fallback_helptext, #" +
                            self.ids.departureStopField
                    )
                        .closest(".contourField")
                        .removeClass("disabled")
                        .addClass("active");

                    try {
                        self.apis.getDepartureBusStop(
                            date,
                            busId,
                            busLineNumber,
                            function (busStops) {
                                populateFromStopField(
                                    JSON.parse(busStops.Data)
                                );
                            }
                        );
                    } catch (error) {
                        console.error(error);
                    }
                }

                function populateFromStopField(busStops) {
                    var filteredBusStop = busStops.filter(function (obj) {
                        if (obj.endsWith(" ")) {
                            return obj.slice(0, -1) === busLineStopDeparture;
                        }
                        return obj === busLineStopDeparture;
                    });

                    filteredBusStop = filteredBusStop.filter(onlyUnique);

                    $("#" + self.ids.departureStopField)
                        .empty()
                        .append(
                            $("<option>", {
                                value: filteredBusStop,
                                text: filteredBusStop,
                            })
                        );

                    try {
                        self.apis.getRouteDestination(
                            date,
                            busId,
                            busLineNumber,
                            filteredBusStop,
                            function (destinations) {
                                $("#" + self.ids.destinationField)
                                    .closest(".contourField")
                                    .removeClass("disabled")
                                    .addClass("active");

                                populateDestinationField(
                                    JSON.parse(destinations.Data),
                                    filteredBusStop
                                );
                            }
                        );
                    } catch (error) {
                        console.error(error);
                    }
                }

                function populateDestinationField(destinations, busStop) {
                    var filteredDestination = destinations.filter(function (
                        obj
                    ) {
                        return obj === busLineEndStop;
                    });

                    $("#" + self.ids.destinationField)
                        .empty()
                        .append(
                            $("<option>", {
                                value: filteredDestination,
                                text: filteredDestination,
                            })
                        );

                    try {
                        self.apis.getDepartureTime(
                            date,
                            busId,
                            busLineNumber,
                            busStop,
                            filteredDestination,
                            function (departureTimes) {
                                $("#" + self.ids.departureTimeField)
                                    .closest(".contourField")
                                    .removeClass("disabled")
                                    .addClass("active");

                                populateDepartureTimeField(
                                    JSON.parse(departureTimes.Data),
                                    busStop
                                );
                            }
                        );
                    } catch (error) {
                        console.error(error);
                    }
                }

                function populateDepartureTimeField(departureTimes, busStop) {
                    var filteredDepartureTime = departureTimes.filter(function (
                        obj
                    ) {
                        return obj.TourNumber === parseInt(busLineTourNumber);
                    });

                    var option = filteredDepartureTime[0].DepartureTime.slice(
                        0,
                        -3
                    );

                    $("#" + self.ids.departureTimeField)
                        .empty()
                        .append(
                            $("<option>", {
                                value: option,
                                text: option,
                            })
                        );

                    try {
                        self.apis.getNextBusLineStops(
                            date,
                            busId,
                            busLineNumber,
                            busLineTourNumber,
                            busStop,
                            function (nextStops) {
                                $("#" + self.ids.arrivalStopField)
                                    .closest(".contourField")
                                    .removeClass("disabled")
                                    .addClass("active");

                                populateArrivalStopField(
                                    JSON.parse(nextStops.Data)
                                );
                            }
                        );
                    } catch (error) {
                        console.error(error);
                    }
                }

                function populateArrivalStopField(nextStops) {
                    var filteredBusStop = nextStops.filter(function (obj) {
                        if (obj.StopName.endsWith(" ")) {
                            return (
                                obj.StopName.slice(0, -1) === busLineStopArrival
                            );
                        }
                        return obj.StopName === busLineStopArrival;
                    });

                    $("#" + self.ids.arrivalStopField)
                        .empty()
                        .append(
                            $("<option>", {
                                value: filteredBusStop[0].StopName.trim(),
                                text: filteredBusStop[0].StopName.trim(),
                            })
                        );

                    $("#" + self.ids.arrivalTimeField)
                        .closest(".contourField")
                        .removeClass("disabled")
                        .addClass("active");

                    populateArrivalTimeField(filteredBusStop[0].ArrivalTime);
                }

                function populateArrivalTimeField(arrivalTime) {
                    $("#" + self.ids.arrivalTimeField)
                        .empty()
                        .append(
                            $("<option>", {
                                value: arrivalTime.slice(0, -3),
                                text: arrivalTime.slice(0, -3),
                            })
                        );

                    populateDescriptionFieldWithCaseId();
                }

                function populateDescriptionFieldWithCaseId() {
                    $(
                        "#" +
                            self.ids.descriptionField +
                            ", #" +
                            self.ids.transportformBusListField
                    )
                        .closest(".contourFieldSet")
                        .css("display", "block");
                    $("#" + self.ids.descriptionField).append(
                        "Sagsnr: " + caseId
                    );

                    renderTransportformList();
                }

                function renderTransportformList() {
                    console.log(travelType);
                    if (travelType === "Bus") {
                        return $("#" + self.ids.transportformBusListField)
                            .closest(".contourField")
                            .css("display", "block");
                    }

                    return $("#" + self.ids.transportformRailwayListField)
                        .closest(".contourField")
                        .css("display", "block");
                }

                // Run above functions on load
                if (travelType && travelType !== "") {
                    setTravelTypeField();
                }
            }
        });
    };

    this.onRadioButtonChange = function () {
        var inputFields = $(".contourField div input");

        inputFields
            .filter(function () {
                var parents = $(this).parents(".contourFieldSet");
                return (
                    $(this).attr("type") == "text" &&
                    $(parents).css("display") == "none"
                );
            })
            .each(function () {
                $(this).val("");
            });
    };

    this.onTravelTypeChange = function () {
        $(
            "#" +
                self.ids.busListField +
                ", #" +
                self.ids.departureStopField +
                ", #" +
                self.ids.destinationField +
                ", #" +
                self.ids.departureTimeField +
                ", #" +
                self.ids.arrivalStopField +
                ", #" +
                self.ids.arrivalTimeField +
                ", .rutenr_helptext, .fallback_helptext"
        )
            .closest(".contourField")
            .removeClass("active")
            .addClass("disabled");

        $("input[type=date]").val("");

        if (
            document.querySelector(
                'input[name="' + self.ids.travelTypeField + '"]:checked'
            ).value != "Bus"
        ) {
            $("label[for='" + self.ids.busListField + "']").text(
                "Rutenr. (L1/L2/92/93) *"
            );
        } else {
            $("label[for='" + self.ids.busListField + "']").text("Rutenr. *");
        }
    };

    this.onTravelCompanyChange = function (e) {
        var company = document.querySelector(
            'input[name="' + self.ids.travelCompanyField + '"]:checked'
        ).value;

        if (company == "Midttrafik") {
            $('input[type="submit"]').removeAttr("disabled");
            $('input[type="submit"]').removeClass("disabled");
        } else {
            $('input[type="submit"]').attr("disabled", "disabled");
            $('input[type="submit"]').addClass("disabled");
        }

        $(
            "#" +
                self.ids.busListField +
                ", .rutenr_helptext, .fallback_helptext, #" +
                self.ids.departureStopField +
                ", #" +
                self.ids.destinationField +
                ", #" +
                self.ids.departureTimeField +
                ", #" +
                self.ids.arrivalStopField +
                ", #" +
                self.ids.arrivalTimeField
        )
            .closest(".contourField")
            .removeClass("active")
            .addClass("disabled");
    };

    this.onDatepickerChange = function (e) {
        $(
            "#" +
                self.ids.busListField +
                ", #" +
                self.ids.departureStopField +
                ", #" +
                self.ids.destinationField +
                ", #" +
                self.ids.departureTimeField +
                ", #" +
                self.ids.arrivalStopField +
                ", #" +
                self.ids.arrivalTimeField
        )
            .closest(".contourField")
            .removeClass("active")
            .addClass("disabled");
        $("#" + self.ids.busListField).val("");

        [year, month, day] = e.target.value.split("-");

        self.apis.getBusList(year + "-" + month + "-" + day, function (data) {
            var jsonData = JSON.parse(data.Data);
            var sortedData = jsonData.sort(compare);
            var radioButtonField = document.querySelector(
                'input[name="' + self.ids.travelTypeField + '"]:checked'
            ).value;

            if (radioButtonField !== "Bus") {
                var routes = sortedData.filter(function (el) {
                    return (
                        el.LineNumber == "L1" ||
                        el.LineNumber == "L2" ||
                        el.LineNumber == "92Tog" ||
                        el.LineNumber == "93Tog"
                    );
                });

                window.Midttrafik2016.routeListTypeahead(
                    "#" + self.ids.busListField,
                    routes
                );
            } else {
                var routes = sortedData.filter(function (el) {
                    return (
                        el.LineNumber !== "L1" &&
                        el.LineNumber !== "L2" &&
                        el.LineNumber !== "92Tog" &&
                        el.LineNumber !== "93Tog"
                    );
                });
                window.Midttrafik2016.routeListTypeahead(
                    "#" + self.ids.busListField,
                    routes
                );
            }
        });
        $(
            "#" +
                self.ids.busListField +
                ", .rutenr_helptext, .fallback_helptext"
        )
            .closest(".contourField")
            .removeClass("disabled")
            .addClass("active");
    };

    this.onRouteListChange = function () {
        $(
            "#" +
                self.ids.departureStopField +
                ", #" +
                self.ids.destinationField +
                ", #" +
                self.ids.departureTimeField +
                ", #" +
                self.ids.arrivalStopField +
                ", #" +
                self.ids.arrivalTimeField
        )
            .closest(".contourField")
            .removeClass("active")
            .addClass("disabled");

        [year, month, day] = document
            .getElementById(self.ids.dateField)
            .value.split("-");
        var routeText = document.getElementById(self.ids.busListField).value;

        self.apis.getBusList(year + "-" + month + "-" + day, function (data) {
            var json = JSON.parse(data.Data);

            $.each(
                json.filter(function (obj) {
                    if (obj.LineDisplayText === routeText) {
                        var busId = obj.RawdataId;
                        var busNumber = obj.LineNumber;

                        self.apis.getDepartureBusStop(
                            year + "-" + month + "-" + day,
                            busId,
                            busNumber,
                            function (busStopData) {
                                $("#" + self.ids.departureStopField)
                                    .closest(".contourField")
                                    .removeClass("disabled")
                                    .addClass("active");

                                var jsonData = JSON.parse(busStopData.Data);
                                var uniqueJsonData = jsonData
                                    .filter(onlyUnique)
                                    .sort(function (a, b) {
                                        function getCode(c) {
                                            c = c.toLowerCase();
                                            if (c.substring(0, 2) == "aa")
                                                return 300;
                                            switch (c.charCodeAt(0)) {
                                                case 229: //å
                                                    return 299;
                                                case 248: //ø
                                                    return 298;
                                                case 230: //æ
                                                    return 297;
                                                default:
                                                    return c.charCodeAt(0);
                                            }
                                        }
                                        return getCode(a) - getCode(b);
                                    });

                                $("#" + self.ids.departureStopField).each(
                                    function () {
                                        $(this.options).remove();
                                    }
                                );

                                $("#" + self.ids.departureStopField).append(
                                    $("<option>", {
                                        value: "",
                                        text: "Vælg et stoppested",
                                        disabled: true,
                                        selected: true,
                                    })
                                );

                                $.each(uniqueJsonData, function (key, value) {
                                    $("#" + self.ids.departureStopField).append(
                                        $("<option></option>")
                                            .attr("value", value)
                                            .text(value)
                                    );
                                });
                            }
                        );
                    }
                })
            );
        });
    };

    this.onFromStopChange = function () {
        $(
            "#" +
                self.ids.departureTimeField +
                ", #" +
                self.ids.arrivalStopField +
                ", #" +
                self.ids.arrivalTimeField
        )
            .closest(".contourField")
            .removeClass("active")
            .addClass("disabled");

        [year, month, day] = document
            .getElementById(self.ids.dateField)
            .value.split("-");
        var routeText = document.getElementById(self.ids.busListField).value;

        self.apis.getBusList(year + "-" + month + "-" + day, function (data) {
            var json = JSON.parse(data.Data);

            $.each(
                json.filter(function (obj) {
                    if (obj.LineDisplayText === routeText) {
                        var busId = obj.RawdataId;
                        var busNumber = obj.LineNumber;
                        var e = document.getElementById(
                            self.ids.departureStopField
                        );
                        var busStopDeparture = e.options[e.selectedIndex].text;

                        self.apis.getRouteDestination(
                            year + "-" + month + "-" + day,
                            busId,
                            busNumber,
                            busStopDeparture,
                            function (routeDestinationData) {
                                var jsonData = JSON.parse(
                                    routeDestinationData.Data
                                );

                                $("#" + self.ids.destinationField).each(
                                    function () {
                                        $(this.options).remove();
                                    }
                                );

                                $("#" + self.ids.destinationField).append(
                                    $("<option>", {
                                        value: "",
                                        text: "Vælg en endestation",
                                        disabled: true,
                                        selected: true,
                                    })
                                );

                                if (jsonData.length > 1) {
                                    $.each(jsonData, function (key, value) {
                                        $(
                                            "#" + self.ids.destinationField
                                        ).append(
                                            $("<option></option>")
                                                .attr("value", value)
                                                .text(value)
                                        );
                                    });
                                } else if (jsonData.length == 1) {
                                    $("#" + self.ids.destinationField).append(
                                        $("<option>", {
                                            value: jsonData,
                                            text: jsonData,
                                        })
                                    );
                                }
                            }
                        );
                    }
                })
            );

            $("#" + self.ids.destinationField)
                .closest(".contourField")
                .removeClass("disabled")
                .addClass("active");
        });
    };

    this.onDestionationChange = function () {
        $(
            "#" +
                self.ids.departureTimeField +
                ", #" +
                self.ids.arrivalStopField +
                ", #" +
                self.ids.arrivalTimeField
        )
            .closest(".contourField")
            .removeClass("active")
            .addClass("disabled");

        [year, month, day] = document
            .getElementById(self.ids.dateField)
            .value.split("-");
        var routeText = document.getElementById(self.ids.busListField).value;
        var busStopDeparture = document.getElementById(
            self.ids.departureStopField
        ).options[
            document.getElementById(self.ids.departureStopField).selectedIndex
        ].text;

        var busEndStop = document.getElementById(self.ids.destinationField)
            .options[
            document.getElementById(self.ids.destinationField).selectedIndex
        ].text;

        self.apis.getBusList(year + "-" + month + "-" + day, function (data) {
            var json = JSON.parse(data.Data);

            $.each(
                json.filter(function (obj) {
                    if (obj.LineDisplayText === routeText) {
                        var busId = obj.RawdataId;
                        var busNumber = obj.LineNumber;

                        self.apis.getDepartureTime(
                            year + "-" + month + "-" + day,
                            busId,
                            busNumber,
                            busStopDeparture,
                            busEndStop,
                            function (departureTimeData) {
                                var departureTimeJsonData = JSON.parse(
                                    departureTimeData.Data
                                );

                                $("#" + self.ids.departureTimeField).each(
                                    function () {
                                        $(this.options).remove();
                                    }
                                );

                                $("#" + self.ids.departureTimeField).append(
                                    $("<option>", {
                                        value: "",
                                        text: "Vælg et tidspunkt for køreplans afgang",
                                        disabled: true,
                                        selected: true,
                                    })
                                );

                                $.each(
                                    departureTimeJsonData,
                                    function (key, value) {
                                        var formattedTime =
                                            value.DepartureTime.slice(0, -3);
                                        $(
                                            "#" + self.ids.departureTimeField
                                        ).append(
                                            $("<option></option>")
                                                .attr("value", formattedTime)
                                                .text(formattedTime)
                                        );
                                    }
                                );
                            }
                        );
                    }
                })
            );
        });

        $("#" + self.ids.departureTimeField)
            .closest(".contourField")
            .removeClass("disabled")
            .addClass("active");
    };

    this.onDepartureTimeChange = function () {
        $("#" + self.ids.arrivalStopField + ", #" + self.ids.arrivalTimeField)
            .closest(".contourField")
            .removeClass("active")
            .addClass("disabled");

        [year, month, day] = document
            .getElementById(self.ids.dateField)
            .value.split("-");
        var routeText = document.getElementById(self.ids.busListField).value;
        var busStopDeparture = document.getElementById(
            self.ids.departureStopField
        ).options[
            document.getElementById(self.ids.departureStopField).selectedIndex
        ].text;

        var departureTime =
            document.getElementById(self.ids.departureTimeField).options[
                document.getElementById(self.ids.departureTimeField)
                    .selectedIndex
            ].text + ":00";

        var busEndStop = document.getElementById(self.ids.destinationField)
            .options[
            document.getElementById(self.ids.destinationField).selectedIndex
        ].text;

        self.apis.getBusList(year + "-" + month + "-" + day, function (data) {
            var json = JSON.parse(data.Data);

            $.each(
                json.filter(function (obj) {
                    if (obj.LineDisplayText === routeText) {
                        var busId = obj.RawdataId;
                        var busNumber = obj.LineNumber;

                        self.apis.getDepartureTime(
                            year + "-" + month + "-" + day,
                            busId,
                            busNumber,
                            busStopDeparture,
                            busEndStop,
                            function (departureTimeData) {
                                var departureTimeJsonData = JSON.parse(
                                    departureTimeData.Data
                                );

                                $.each(
                                    departureTimeJsonData.filter(function (el) {
                                        if (
                                            el.DepartureTime === departureTime
                                        ) {
                                            var tourNumber = el.TourNumber;

                                            self.apis.getNextBusLineStops(
                                                year + "-" + month + "-" + day,
                                                busId,
                                                busNumber,
                                                tourNumber,
                                                busStopDeparture,
                                                function (nextBusStop) {
                                                    var stopName = JSON.parse(
                                                        nextBusStop.Data
                                                    );

                                                    $(
                                                        "#" +
                                                            self.ids
                                                                .arrivalStopField
                                                    ).each(function () {
                                                        $(
                                                            this.options
                                                        ).remove();
                                                    });

                                                    $(
                                                        "#" +
                                                            self.ids
                                                                .arrivalStopField
                                                    ).append(
                                                        $("<option>", {
                                                            value: "",
                                                            text: "Vælg et stoppested",
                                                            disabled: true,
                                                            selected: true,
                                                        })
                                                    );

                                                    $.each(
                                                        stopName,
                                                        function (key, value) {
                                                            $(
                                                                "#" +
                                                                    self.ids
                                                                        .arrivalStopField
                                                            ).append(
                                                                $(
                                                                    "<option></option>"
                                                                )
                                                                    .attr(
                                                                        "value",
                                                                        value.StopName
                                                                    )
                                                                    .text(
                                                                        value.StopName
                                                                    )
                                                            );
                                                        }
                                                    );
                                                }
                                            );
                                        }
                                    })
                                );
                            }
                        );
                    }
                })
            );
        });

        $("#" + self.ids.arrivalStopField)
            .closest(".contourField")
            .removeClass("disabled")
            .addClass("active");
    };

    this.onArrivalBusStopChange = function () {
        $("#" + self.ids.arrivalTimeField)
            .closest(".contourField")
            .removeClass("active")
            .addClass("disabled");

        [year, month, day] = document
            .getElementById(self.ids.dateField)
            .value.split("-");
        var routeText = document.getElementById(self.ids.busListField).value;
        var busStopDeparture = document.getElementById(
            self.ids.departureStopField
        ).options[
            document.getElementById(self.ids.departureStopField).selectedIndex
        ].text;

        var departureTime =
            document.getElementById(self.ids.departureTimeField).options[
                document.getElementById(self.ids.departureTimeField)
                    .selectedIndex
            ].text + ":00";

        var busEndStop = document.getElementById(self.ids.destinationField)
            .options[
            document.getElementById(self.ids.destinationField).selectedIndex
        ].text;

        var arrivalBusStop = document.getElementById(self.ids.arrivalStopField)
            .options[
            document.getElementById(self.ids.arrivalStopField).selectedIndex
        ].text;

        self.apis.getBusList(year + "-" + month + "-" + day, function (data) {
            var json = JSON.parse(data.Data);

            $.each(
                json.filter(function (obj) {
                    if (obj.LineDisplayText === routeText) {
                        var busId = obj.RawdataId;
                        var busNumber = obj.LineNumber;

                        self.apis.getDepartureTime(
                            year + "-" + month + "-" + day,
                            busId,
                            busNumber,
                            busStopDeparture,
                            busEndStop,
                            function (departureTimeData) {
                                var departureTimeJsonData = JSON.parse(
                                    departureTimeData.Data
                                );

                                $.each(
                                    departureTimeJsonData.filter(function (el) {
                                        if (
                                            el.DepartureTime === departureTime
                                        ) {
                                            var tourNumber = el.TourNumber;

                                            self.apis.getNextBusLineStops(
                                                year + "-" + month + "-" + day,
                                                busId,
                                                busNumber,
                                                tourNumber,
                                                busStopDeparture,
                                                function (nextBusStop) {
                                                    var stopName = JSON.parse(
                                                        nextBusStop.Data
                                                    );

                                                    $.each(
                                                        stopName.filter(
                                                            function (x) {
                                                                if (
                                                                    x.StopName ===
                                                                    arrivalBusStop
                                                                ) {
                                                                    var formattedTime =
                                                                        x.ArrivalTime.slice(
                                                                            0,
                                                                            -3
                                                                        );

                                                                    $(
                                                                        "#" +
                                                                            self
                                                                                .ids
                                                                                .arrivalTimeField
                                                                    ).each(
                                                                        function () {
                                                                            $(
                                                                                this
                                                                                    .options
                                                                            ).remove();
                                                                        }
                                                                    );

                                                                    $(
                                                                        "#" +
                                                                            self
                                                                                .ids
                                                                                .arrivalTimeField
                                                                    ).append(
                                                                        $(
                                                                            "<option>",
                                                                            {
                                                                                value: formattedTime,
                                                                                text: formattedTime,
                                                                            }
                                                                        )
                                                                    );
                                                                }
                                                            }
                                                        )
                                                    );
                                                }
                                            );
                                        }
                                    })
                                );
                            }
                        );
                    }
                })
            );
        });

        $("#" + self.ids.arrivalTimeField)
            .closest(".contourField")
            .removeClass("disabled")
            .addClass("active");
    };
})();
